const API_URL = 'https://fierce-harbor-47064.herokuapp.com/api/v1/anime';

export {
    API_URL,
}